__turbopack_context__.v({
  "body": "BannerCard-module-scss-module__JAo2PW__body",
  "card": "BannerCard-module-scss-module__JAo2PW__card",
  "image": "BannerCard-module-scss-module__JAo2PW__image",
});
